<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="customer.customer_name + ' - WTS'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/customers">Customers</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/customers/${customer.id}`">{{ customer.customer_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Delete</li>
                </ol>
            </nav>

            <h4 class="page-header">
                <i class="fas fa-trash"></i> Delete: {{ customer.customer_name }}
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card">
                        <div class="card-header">Delete Customer</div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to permanently delete this customer. Select a replacement This will reassign ALL entries and data to the customer selected below.
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Replacement Customer:</div>
                                <div class="col-md-7">
                                    <b-form-select v-model="replacement_customer_id" :options="typeOptions" :class="{'is-invalid': errors.replacement_customer_id}"></b-form-select>

                                    <div class="text-danger mt-2" v-if="errors.replacement_customer_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.replacement_customer_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-danger" v-on:click="deleteCustomer()" :disabled="deleting">
                                <template v-if="deleting">
                                    <i class="fas fa-spinner fa-spin"></i> Deleting...
                                </template>
                                <template v-else>
                                    <i class="fas fa-trash"></i> Delete Customer
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                tz: this.$root.timezone,
                id: this.$route.params.id,
                customer: {},
                errors: {},
                replacement_customer_id: null,
                otherCustomers: [],
            }
        },

        computed: {
            typeOptions(){
                //Setup
                var options = [{value: null, text: '-- Select Replacement Customer --'}];

                //Build the list
                for (var i = 0; i < this.otherCustomers.length; i++)
                {
                    options.push({value: this.otherCustomers[i].id, text: this.otherCustomers[i].customer_name});
                }

                //Send it
                return options;
            },
        },

        methods: {
            //Get the Customer
            getCustomer(){
                //Send it
                this.$http.get('/customers/'+this.id, {delete: true})
                    .then(response => {
                        //Set the customer
                        this.customer = response.data.customer;
                        this.otherCustomers = response.data.otherCustomers;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteCustomer(){
                //Deleting
                this.deleting = true;

                //Send it
                this.$http.delete('/customers/'+this.id, {replacement_customer_id: this.replacement_customer_id})
                    .then(response => {
                        //Alert the customer
                        this.$toastr.s('Customer Deleted');

                        //Set the customer
                        this.$router.push('/customers');
                    })
                    .catch(error => {
                        //Set the error
                        if(error.response)
                        {
                            switch(error.response.status)
                            {
                                case 422:
                                    this.errors = error.response.data.errors;
                                    break;
                                default:
                                    //Log it
                                    console.log(error.response.data);

                                    //Alert the user
                                    this.$toastr.e(JSON.stringify(error.response.data), error.response.status + ': Error');
                                    break;
                            }
                        }
                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            }
        },

        mounted() {
            //Get the customer
            this.getCustomer();
        }
    }
</script>
